import { Divider, Skeleton } from '@chakra-ui/react';
import DeleteIcon from '@mui/icons-material/Delete';
import LinkIcon from '@mui/icons-material/Link';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { format } from 'date-fns';
import { getDaysDistanceFromDate } from '@/pages/JobsList/JobsList.utils';
import { trioUITheme } from '@/styles/theme';
import { Job } from '@/types/api';
import * as Styles from './JobResume.styles';
import Menu from '../Menu';

type JobResumeProps = {
  job?: Job;
  openDeleteDialog: () => void;
  hideDateInfos: boolean;
  className?: string;
};

const JobResume = function ({
  job,
  openDeleteDialog,
  hideDateInfos,
  className,
}: JobResumeProps): JSX.Element {
  const mask = '---';

  const createdAtFormated = job ? format(new Date(job.createdAt), 'MMM d HH:mm a') : '';
  const [labelFormated, days] = job ? getDaysDistanceFromDate(job.createdAt) : ['', 0];

  return (
    <Styles.Box data-testid="job-info" className={className}>
      {job ? (
        <Styles.Title data-testid="job-title">{job?.title}</Styles.Title>
      ) : (
        <Skeleton className="tw-h-[26px] tw-w-[220px] tw-my-[3px]" />
      )}
      {job && (
        <>
          <Divider height={30} marginX={22} orientation="vertical" />

          <Styles.StatusAndPartnerBox>
            <Styles.Tag
              outlined
              status={job.status === 'Active' ? 'Open' : job.status}
              statusColor={trioUITheme.colors['purple-50']}
            />
            for <strong data-testid="job-partner-name">&nbsp;{job.account?.name}</strong>
          </Styles.StatusAndPartnerBox>

          <Divider height={30} marginX={22} orientation="vertical" />

          <Styles.ContactLink
            isDisabled={!job.jobLink}
            href={job.jobLink || ''}
            target="_blank"
            rel="noreferrer"
            data-testid="job-link"
          >
            <LinkIcon />
            <span>{job.jobLink || mask}</span>
          </Styles.ContactLink>

          <Divider height={30} marginX={22} orientation="vertical" />

          {!hideDateInfos && (
            <Styles.DateBox data-testid="job-date">
              Created on {createdAtFormated}
              <Styles.TimeOpenText days={days}>{labelFormated}</Styles.TimeOpenText>
            </Styles.DateBox>
          )}

          <Menu
            icon={MoreHorizIcon}
            menuId="delete-job-button"
            menuItems={[
              {
                label: 'Delete',
                menuItemOptions: { warning: true },
                menuItemIcon: DeleteIcon,
                callback: (e) => {
                  e.stopPropagation();
                  openDeleteDialog();
                },
              },
            ]}
          />
        </>
      )}
    </Styles.Box>
  );
};

export default JobResume;
